export type Lang = "es" | "en";

const ES_TO_EN: Record<string, string> = {
  "/": "/en",
  "/servicios": "/en/services",
  "/contacto": "/en/contact",
  "/soluciones-a-medida": "/en/custom-solutions",
  "/demo": "/en/demo",

  "/legal/aviso-legal": "/en/legal/notice",
  "/legal/privacidad": "/en/legal/privacy",
  "/legal/cookies": "/en/legal/cookies",
  "/politica-cookies": "/en/legal/cookies",
};

const EN_TO_ES: Record<string, string> = Object.fromEntries(
  Object.entries(ES_TO_EN).map(([es, en]) => [en, es]),
);

export function navLink(lang: Lang, esPath: string) {
  if (lang === "en") return ES_TO_EN[esPath] ?? `/en${esPath}`;
  return esPath;
}

export function switchLangPath(currentPath: string, nextLang: Lang) {
  const isEn = currentPath.startsWith("/en");

  if (nextLang === "en") {
    if (isEn) return currentPath;
    return ES_TO_EN[currentPath] ?? `/en${currentPath}`;
  }

  // nextLang === "es"
  if (!isEn) return currentPath;
  return EN_TO_ES[currentPath] ?? (currentPath.replace(/^\/en/, "") || "/");
}
